import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiButton, EuiFormRow, EuiPage, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { useGetMasterCampaignPlansQuery } from 'api/rtkQueryApi/platform/masterCampaignPlansApi'
import { RootState } from 'app/rootReducer'
import { reset } from 'features/planner/CreateMasterCampaignPlanSlice'

import history from '../../services/HistoryService'

export const MasterCampaignPlanWelcomePage: React.FC = () => {
  const dispatch = useDispatch()
  const { currentOrganization, currentAccount } = useSelector((state: RootState) => state.app)
  const { data: plans } = useGetMasterCampaignPlansQuery({ organizationId: currentOrganization?.id ?? '' })

  useEffect(() => {
    if (!currentAccount || !plans) {
      return
    }

    const currentAccountPlans = plans?.filter(plan => plan.accountId === currentAccount?.id)

    if (currentAccountPlans.length <= 0) {
      return
    }

    dispatch(reset())
    history.push('/ai')
  }, [currentAccount, dispatch, plans])

  const onCreateMasterCampaignPlanClick = () => {
    history.push('/ai/create-plan')
  }

  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <EuiPageHeader>
          <EuiPageHeaderSection>
            <EuiTitle>
              <h1> AdCritter AI</h1>
            </EuiTitle>
            <EuiText>Welcome to AdCritter AI!</EuiText>
          </EuiPageHeaderSection>
        </EuiPageHeader>
        <EuiPanel grow={false} className='eui-xScroll'>
          <EuiTitle size={'s'}>
            <h2>It's a Game Changer</h2>
          </EuiTitle>
          <EuiSpacer />
          <EuiText>To get started with AdCritter AI, simply enter your client’s URL. Within twenty-four hours, AdCritter AI will generate a detailed media plan of strategically targeted campaigns along with supporting research and planning documents for your sales motion.</EuiText>
          <EuiSpacer />
          <EuiText>Once you’ve reviewed the plan, everything in it can then be edited by you.</EuiText>
          <EuiSpacer />
          <EuiText>Next, you’ll receive client-friendly PDFs, as well as a client preview link, to help in your selling and approval process. Both the PDFs and the preview link are “unbranded.”</EuiText>
          <EuiSpacer />
          <EuiText>Once you are happy with the plan, a simple click transfers it to the AdCritter DSP for execution. </EuiText>
          <EuiSpacer />
          <EuiFormRow>
            <EuiButton fill onClick={onCreateMasterCampaignPlanClick}>
              Let's get started!
            </EuiButton>
          </EuiFormRow>
        </EuiPanel>
      </EuiPageBody>
    </EuiPage>
  )
}
